import React from 'react';

import { useBreakpoints } from '@/hooks';

import { LazyLoader } from './lazy-loader';
import { NumberPagination } from './number-pagination';

import * as S from './pagination.styles';

export const Pagination: React.FC = () => {
  const { isMobile } = useBreakpoints();

  const PaginationComponent = isMobile ? LazyLoader : NumberPagination;

  return (
    <S.Container>
      <PaginationComponent />
    </S.Container>
  );
};
